module.exports = __webpack_public_path__ + "img/driver-empty-img5.2839dc0d.png";